import { Entity } from '../../../domain/entity'
import { SimpleEvents } from '../../../utils/events'
import { IProviderConfig } from '../../common/provider-config'

export enum SSOScreen {
    SIGN_IN = 'signIn',
    SIGN_OUT = 'signOut'
}

export interface IIdentityServiceAdapter<T extends IIdentityProviderConfig> extends SimpleEvents {
    enable(): void
    initialize(creds: T, ...args: any[]): this
    registerInitHandler(): void
    signIn(): void
    signOut(): void
}

export interface ISubscriberServiceAdapter extends IIdentityServiceAdapter<IIdentityProviderConfig> {
    getAccess(): Promise<ISubscription[]>
}

export interface IIdentityProviderConfig extends IProviderConfig {
    application?: string
}

export interface ISubscriberProviderConfig extends IIdentityProviderConfig {
    /**
     * Whitelist of subscription ids that determine if a user is a subscriber.
     */
    resIds?: string[]
}

export interface ISubscription {
    end?: number
    id: string
    start: number
}

export class Subscription extends Entity implements ISubscription {
    public end?: number
    public id: string
    public start: number
}
